// src/pages/TabletSelection.js
import React from 'react';
import { Link } from 'react-router-dom';
// Reverted back to Si icons for tablet brands
import { SiApple, SiSamsung } from 'react-icons/si';
// Kept Fa icons for general UI elements
import { FaWrench } from 'react-icons/fa';

// Button style for consistency
const contactLinkStyle = {
    display: 'inline-block', alignItems: 'center', background: '#6c757d', color: '#fff',
    border: '1px solid #6c757d', borderRadius: '4px', padding: '0.5rem 1rem',
    cursor: 'pointer', fontSize: '0.9rem', textDecoration: 'none', fontWeight: '500',
    transition: 'background-color 0.2s, border-color 0.2s', marginLeft: '4px',
};

// --- Brand Data (Optional structure, but helps consistency) ---
const tabletBrands = [
    { name: 'iPad', path: '/tablet/ipad', Icon: SiApple, ariaLabel: 'Select Apple iPad' },
    { name: 'Samsung Tablet', path: '/tablet/samsung', Icon: SiSamsung, ariaLabel: 'Select Samsung Galaxy Tab' },
    // Add other tablet brands like Microsoft Surface (SiMicrosoft) if needed
];
// --- ---

function TabletSelection() {
  return (
    <main className="page-container tablet-selection-page" style={{ padding: '2rem 1rem' }}>
      <header style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
        <h1 style={{ fontSize: '2rem', color: '#212529', marginBottom: '0.5rem' }}>Select Your Tablet Brand</h1>
        <p style={{ fontSize: '1.1rem', color: '#6c757d' }}>Choose your tablet manufacturer to view repair options.</p>
      </header>

      <div className="tablet-grid" style={gridStyle}>
        {tabletBrands.map((brand) => (
          <Link
            key={brand.name}
            to={brand.path}
            className="tablet-item" // Needs CSS
            style={tabletItemStyle} // Basic inline styles
            title={`View ${brand.name} Models`}
            role="button"
            aria-label={brand.ariaLabel}
          >
            <div className="tablet-logo" style={logoContainerStyle}>
              {/* Use Si icon with Kentech medium gray color */}
              <brand.Icon size={50} style={{ color: '#6c757d' }} />
            </div>
            <h3 style={itemHeadingStyle}>{brand.name}</h3>
            <span style={itemTextStyle}>View Models & Repairs</span>
          </Link>
        ))}
      </div>

      <section className="tablet-extra-info" style={extraInfoStyle} aria-labelledby="info-heading">
         <h4 id="info-heading" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', marginBottom: '1rem' }}>
             <FaWrench /> Expert Tablet Repairs
         </h4>
         <p>Fast, reliable service for screens, batteries, charging ports, and more, backed by our warranty.</p>
         <p style={{ marginTop: '1.5rem' }}>
             Need help or your device isn't listed?{' '}
             <Link to="/contact" style={contactLinkStyle}>Contact Us</Link>
         </p>
      </section>
    </main>
  );
}

// --- Inline Styles (Keep as previously defined) ---
const gridStyle = { /* ... */ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '2rem', marginBottom: '3rem', };
const tabletItemStyle = { /* ... */ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '1.5rem', border: '1px solid #dee2e6', borderRadius: '8px', textDecoration: 'none', color: '#495057', minWidth: '200px', textAlign: 'center', transition: 'transform 0.2s ease, box-shadow 0.2s ease', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', backgroundColor: '#fff', };
const logoContainerStyle = { /* ... */ marginBottom: '1rem', height: '50px', display: 'flex', alignItems: 'center', };
const itemHeadingStyle = { /* ... */ margin: '0.5rem 0', fontSize: '1.2rem', color: '#212529', };
const itemTextStyle = { /* ... */ fontSize: '0.9rem', color: '#6c757d', };
const extraInfoStyle = { /* ... */ marginTop: '3rem', padding: '2rem', backgroundColor: '#f8f9fa', border: '1px solid #e9ecef', borderRadius: '8px', textAlign: 'center', maxWidth: '650px', marginLeft: 'auto', marginRight: 'auto', color: '#495057', };
// --- ---

export default TabletSelection;